import ApiService from '../index'

export const getChecklists = async (search = '') => {
  const URI = `/api/checklist?name=${search}`

  const response = await ApiService.get(URI)

  return response.data
}

export const getJobs = async (id) => {
  const URI = `/api/checklist/jobs?condominium_id=${id}`

  const response = await ApiService.get(URI)

  return response.data
}

export const getJobsDetails = async (checklistId, condominiumId) => {
  const URI = `/api/checklist/jobs/activities?checklist_id=${checklistId}&condominium_id=${condominiumId}`

  const response = await ApiService.get(URI)

  return response.data
}

export const saveNewJobs = async (jobList, condominiumId) => {
  const URI = `/api/checklist/jobs?condominium_id=${condominiumId}`

  const response = await ApiService.post(URI, jobList)

  return response.data
}

export const serviceType = async () => {
  const URI = '/api/serviceType'

  const response = await ApiService.get(URI)

  return response.data
}